import { inject, observer } from 'mobx-react'
import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import { runInAction } from 'mobx'
import { useHistory } from 'react-router-dom'
import PageTitle from '../../components/PageTitle'
import AppPageHeader from '../../components/AppPageHeader'
import DashboardLayout from '../../layouts/DashboardLayout'
import ContentBlockWrapper from '../../components/ContentBlockWrapper'
import { Button, Form, Select, Space, Tag, message } from 'antd'
import { Tooltip } from 'chart.js'
import { BankOutlined, TeamOutlined, UserOutlined } from '@ant-design/icons'
import {
  ASSIGNEE_TYPE,
  DOCUMENT_ACCESS_TYPE,
  DOCUMENT_TYPE,
} from '../../constants'
import SelectPeoplePopup from '../../components/SelectPeoplePopup'
import { AvatarHasName } from '../../components/Common/Avatar'
import { blue } from '../../color'
import { FormButtonGroup, SelectList } from './RiskManagementStyled'
import { AuthenticationRequest } from '../../requests/AuthenticationRequest'

const RiskManagement = props => {
  const {
    selectPeopleStore,
    documentAccessibilityStore,
    authenticationStore,
    loadingAnimationStore,
  } = props
  const {
    isVisibleSelectUserDepartmentPopup,
    setIsVisibleSelectUserDepartmentPopup,
    handleOpenSelectUserDepartmentPopup,
    handleCancelSelectUserDepartment,
    selectUserData,
    selectDepartmentData,
    selectGroupData,
  } = selectPeopleStore

  const [form] = Form.useForm()

  const formStyle = {
    paddingLeft: '16px',
  }

  const labelStyle = {
    display: 'inline-block',
    margin: '15px 8px 25px 0',
  }

  const [followerList, setFollowerList] = useState([])
  const [accessType, setAccessType] = useState()
  const [docAccess, setDocAccess] = useState([])

  useEffect(() => {
    return () => {
      selectPeopleStore.clearSelected()
      runInAction(() => {
        documentAccessibilityStore.documentAccessibilities = []
      })
    }
  }, [])

  useEffect(() => {
    ;(async () => {
      if (!accessType) return
      try {
        selectPeopleStore.clearSelected()
        loadingAnimationStore.showSpinner(true)
        const response = await documentAccessibilityStore.getDocumentAccessibilities(
          'RISK',
          'VIEW_ALL'
        )
        setDocAccess(response.data)
      } catch (error) {
        message.error(error.vi)
        console.log(error)
      } finally {
        loadingAnimationStore.showSpinner(false)
      }
    })()
  }, [accessType])

  useEffect(() => {
    documentAccessibilityStore.documentAccessibilities
      .map(accessibility => accessibility.assignee)
      .forEach(follower => {
        if (follower?.user_name) {
          followerList.push({
            assignee_type: ASSIGNEE_TYPE.USER,
            full_name: follower.name_uppercase,
            id: follower.user_name,
            image_id: null,
            permission: ASSIGNEE_TYPE.USER,
          })
        }
      })

    if (followerList.length > 0) {
      selectPeopleStore.setSelectUserData({
        ...selectUserData,
        USER: followerList,
      })
    }
  }, [documentAccessibilityStore.documentAccessibilities])

  useEffect(() => {
    setFollowerList([
      ...selectUserData[ASSIGNEE_TYPE.USER],
      ...selectDepartmentData[ASSIGNEE_TYPE.USER],
      ...selectGroupData[ASSIGNEE_TYPE.USER],
    ])
  }, [selectUserData, selectDepartmentData, selectGroupData])

  const onChangeAccessType = value => {
    setAccessType(value)
  }

  const onFinish = async values => {
    try {
      await documentAccessibilityStore.updateDocumentAccessibilities({
        type: 'RISK',
        access_type: values.accessType,
        username_list: followerList.map(follow => follow.id),
      })
      message.success('Cập nhật quyền thao tác thành công!')
    } catch (error) {
      message.error(error.vi)
      console.log(error)
    }
  }

  return (
    <DashboardLayout>
      <Helmet>
        <title>Quản lý phiếu kiểm soát rủi ro | Phiếu kiểm soát rủi ro</title>
      </Helmet>
      <AppPageHeader title="Quyền xem phiếu kiểm soát rủi ro" />

      <Form
        onFinish={onFinish}
        scrollToFirstError={true}
        name={'document-accessbilities'}
        layout={'vertical'}
        form={form}>
        <div className="custom-create-page-content-wrapper">
          <p style={{ marginTop: '16px' }}>
            <strong>Lưu ý: </strong>
            Quyền được cấp chỉ có tác dụng với dữ liệu tính từ thời điểm cấu
            hình được áp dụng trở về sau
          </p>

          <Form.Item
            label="Quyền truy cập phiếu kiểm soát rủi ro"
            name="accessType"
            rules={[
              {
                required: true,
                message: 'Vui lòng chọn quyền!',
              },
            ]}>
            <Select
              placeholder="Chọn quyền truy cập phiếu kiểm soát rủi ro"
              onChange={onChangeAccessType}
              allowClear
              style={{ width: '100%' }}>
              <Select.Option value={DOCUMENT_ACCESS_TYPE.VIEW_ALL}>
                Xem toàn bộ
              </Select.Option>
            </Select>
          </Form.Item>

          <div>
            <label style={labelStyle}>Người được cấp quyền:</label>

            <Button
              className="select-user-icon-btn"
              icon={<UserOutlined style={{ color: blue }} />}
              onClick={() =>
                handleOpenSelectUserDepartmentPopup(ASSIGNEE_TYPE.USER)
              }
            />
            {/* <Space>
              <Tooltip title="Chọn người dùng" color={blue}>
              </Tooltip>
            </Space> */}

            {followerList.length > 0 && (
              <SelectList style={{ maxHeight: 'unset' }}>
                {followerList
                  .filter(el => el.id !== 'admin_vpdt')
                  .map(el => (
                    <Tag
                      className={'tag-selected'}
                      color={'blue'}
                      key={el.id}
                      closable
                      onClose={() => selectPeopleStore.handleRemoveSelect(el)}>
                      <AvatarHasName
                        imgId={el.image_id}
                        size={22}
                        name={el.full_name}
                        icon={
                          (el.assignee_type === ASSIGNEE_TYPE.DEPARTMENT && (
                            <BankOutlined />
                          )) ||
                          (el.assignee_type === ASSIGNEE_TYPE.GROUP && (
                            <TeamOutlined />
                          ))
                        }
                      />
                    </Tag>
                  ))}
              </SelectList>
            )}
          </div>

          <FormButtonGroup>
            <Button
              style={{ marginTop: 20 }}
              type={'primary'}
              htmlType={'submit'}
              className="cusstom-ant-button w-160">
              Lưu
            </Button>
          </FormButtonGroup>
        </div>

        {/* <div>
          <label style={labelStyle}>Người được cấp quyền:</label>

          <Button
            icon={<UserOutlined style={{ color: blue }} />}
            onClick={() =>
              handleOpenSelectUserDepartmentPopup(ASSIGNEE_TYPE.USER)
            }
          />
       

          {followerList.length > 0 && (
            <SelectList style={{ maxHeight: 'unset' }}>
              {followerList
                .filter(el => el.id !== 'admin_vpdt')
                .map(el => (
                  <Tag
                    className={'tag-selected'}
                    color={'blue'}
                    key={el.id}
                    closable
                    onClose={() => selectPeopleStore.handleRemoveSelect(el)}>
                    <AvatarHasName
                      imgId={el.image_id}
                      size={22}
                      name={el.full_name}
                      icon={
                        (el.assignee_type === ASSIGNEE_TYPE.DEPARTMENT && (
                          <BankOutlined />
                        )) ||
                        (el.assignee_type === ASSIGNEE_TYPE.GROUP && (
                          <TeamOutlined />
                        ))
                      }
                    />
                  </Tag>
                ))}
            </SelectList>
          )}
        </div> */}

        <SelectPeoplePopup
          allowChangeCompany={true}
          companyCode={authenticationStore.currentUser?.company?.code}
          disableSelectDepartment
          handleCancelSelectUser={handleCancelSelectUserDepartment}
          handleSubmitSelectUser={() =>
            setIsVisibleSelectUserDepartmentPopup(false)
          }
          isVisibleSelectPeoplePopup={isVisibleSelectUserDepartmentPopup}
        />
      </Form>
    </DashboardLayout>
  )
}

export default inject(
  'selectUserStore',
  'documentAccessibilityStore',
  'selectPeopleStore',
  'loadingAnimationStore',
  'authenticationStore'
)(observer(RiskManagement))
